import './Datasources.scss'
import Select from 'react-select';
import DataTable from 'react-data-table-component';
import { useContext, useEffect, useState } from 'react';
import { DatasourceContext } from '../../Contexts/DatasourceProvider';
import { toast } from "react-toastify";
import { send, init } from "@emailjs/browser";
import { useSession } from "../../Contexts/Authprovider";


export default function Data(){
  const { datasources,loading,refreshDatasources } = useContext(DatasourceContext)
  useEffect(()=>{
    document.title = "Datasources"
    refreshDatasources()
  },[refreshDatasources])
  const columns = [
    {
        name: 'Year',
        selector: row => row.year,
        sortable: true,
        maxWidth: "20%",
    },
    {
        name: 'Value',
        selector: row => row.value,
    },
];

const [pages,setPages] = useState();
const [options, setOptions] = useState([])
const [selected, setSelected] = useState(null)
const [data, setData] = useState()

const [selectedRows, setSelectedRows] = useState([]);
const [toggledClearRows, setToggleClearRows] = useState(false);

const serviceId = "service_u8eonup";
const templateId = "template_ezc3ktj";
const userID = "user_QbN4SRtbUy8Xku4U9097O";

const { user } = useSession();


function swapSource(value){
  const source = datasources.filter(s => s.datasourceName === value.value);
  setSelected(value)
  setData(source[0].data)
}
useEffect(() => {
  if (window.innerHeight >= 850){
    setPages(12)
  }
  else if(window.innerHeight < 675){
    setPages(7)
  }
  else{
    setPages(10)
  }
},[])

useEffect(() => {
  if (!loading) {
    setTimeout(() => {
      setData(datasources[0].data)
    const data = []
    datasources.forEach((source) => {
      const a = {value: source.datasourceName, label: source.datasourceName}
      data.push(a)
    })

    setOptions(data)
    setSelected(data[0])
  },50)
  }
},[loading])


function handleChange({ selectedRows }) {
  setSelectedRows(selectedRows);
  const element = document.getElementById("reportBtn");
   if(selectedRows.length === 0){
    element.style.visibility = "hidden";
  } else  element.style.visibility = "visible";
 
};

function reportMistake(){
  handleReport(selectedRows);
  const element = document.getElementById("reportBtn");
  element.style.visibility = "hidden";
  setToggleClearRows(!toggledClearRows);
};

function handleReport(selectedRows){
  init(userID);
  const usersName =`${user.firstname} ${user.lastname}`
  const dataToSend = [];
  selectedRows.map((row)=>{
    dataToSend.push(`Year: ${row.year}  Value: ${row.value}`)
  });
        const toSend = {
          data: dataToSend,
          datasource: selected.label,
          user:  usersName,
          email: user.email
        };
        send(serviceId, templateId, toSend)
          .then((res) => {
            toast.success("Reported mistakes!", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          })
          .catch((err) => {
            toast.error("Could not report mistakes.", {
              position: "top-right",
              autoClose: false,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
              });
          });
}

  return (
      <div className='DataContainer' required data-cy='datasources'>
        <div className='toprow'> 
          <Select
            className="SelectMenu"
            classNamePrefix="select"
            value={selected}
            name="color"
            isSearchable="false"
            onChange={value => swapSource(value)}
            options={options}
          />
          <button className='reportMistakeBtn' id="reportBtn" visibility="hidden" onClick={() => reportMistake()}>Report mistakes</button>
        </div>
        <div className='DataTableContainer'>
          {selected != null && pages != null &&
                  <DataTable
                  columns={columns}
                  data={data}
                  pagination
                  responsive={true}
                  paginationPerPage={pages}
                  selectableRows
                  onSelectedRowsChange={handleChange}
                  clearSelectedRows={toggledClearRows}
              />
          }
        </div>

      </div>
  );
}